import createVideoPlayerRoute from "../create-video-player-route";

import FilmArchive from "../../../../views/digibord/content/archive/FilmArchive.vue";

export default [
  {
    path: "filmarchief/",
    name: "FilmArchive",
    component: FilmArchive,
    meta: {
      containerClass: "showVideoSearch",
    },
    children: [...createVideoPlayerRoute("FilmArchiveVideoPlayer")],
  },
];
